<template>
    <div>
        <div 
            data-nav-overlay 
            aria-hidden="true" 
            class="fixed bg-black/50 backdrop-blur-sm inset-0 z-30 lg:hidden"
            :class="{ 'hidden': !isOpen }"
            @click="closeNavbar"
        ></div>
        <header class="sticky top-0 w-full z-40 bg-white/95 backdrop-blur-md border-b border-gray-100/80 shadow-sm">
            <nav class="relative mx-auto lg:max-w-7xl w-full px-4 sm:px-6 lg:px-8 flex justify-between items-center h-20">
                <!-- Logo -->
                <div class="flex items-center">
                    <router-link to="/" class="flex items-center group">
                        <div class="relative p-2">
                            <!-- Logo Image with enhanced visibility -->
                            <img 
                                class="w-24 h-24 object-contain transition-all duration-300 group-hover:scale-105 contrast-125 brightness-110" 
                                :src="require('@/assets/logo3.jpg')" 
                                alt="ltenviromonitoring"
                            />
                        </div>
                    </router-link>
                </div>

                <!-- Desktop Navigation -->
                <div class="hidden lg:flex items-center space-x-1">
                    <div 
                        v-for="(link, index) in navLinks" 
                        :key="index"
                        class="relative"
                    >
                        <router-link 
                            :to="link.path"
                            class="relative px-4 py-2 text-gray-700 font-medium rounded-lg transition-all duration-200 hover:text-green-600 hover:bg-green-50/50 group"
                        >
                            {{ link.name }}
                            <span class="absolute bottom-0 left-1/2 w-0 h-0.5 bg-gradient-to-r from-green-600 to-teal-600 transition-all duration-300 group-hover:w-8 group-hover:left-1/2 group-hover:-translate-x-1/2"></span>
                        </router-link>
                    </div>
                    
                    <!-- CTA Button -->
                    <router-link 
                        to="/Contact"
                        class="ml-4 px-6 py-2.5 bg-gradient-to-r from-green-600 to-teal-600 text-white font-medium rounded-full transition-all duration-300 hover:from-green-700 hover:to-teal-700 hover:shadow-lg hover:scale-105"
                    >
                        Get Quote
                    </router-link>
                </div>

                <!-- Mobile Menu Button -->
                <button 
                    class="lg:hidden outline-none relative p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                    @click="toggleNavbar"
                    aria-label="toggle navbar"
                >
                    <div class="w-6 h-5 relative flex flex-col justify-center items-center">
                        <span 
                            class="absolute w-6 h-0.5 bg-gray-700 transition-all duration-300"
                            :class="isOpen ? 'rotate-45 translate-y-0' : '-translate-y-2'"
                        ></span>
                        <span 
                            class="w-6 h-0.5 bg-gray-700 transition-all duration-300"
                            :class="isOpen ? 'opacity-0' : 'opacity-100'"
                        ></span>
                        <span 
                            class="absolute w-6 h-0.5 bg-gray-700 transition-all duration-300"
                            :class="isOpen ? '-rotate-45 translate-y-0' : 'translate-y-2'"
                        ></span>
                    </div>
                </button>

                <!-- Mobile Navigation -->
                <div 
                    class="absolute top-full left-0 right-0 lg:hidden bg-white/95 backdrop-blur-md border-b border-gray-100/80 shadow-lg
                    transition-all duration-300 ease-in-out"
                    :class="[
                        isOpen ? 'translate-y-0 opacity-100 visible' : 'translate-y-2 opacity-0 invisible'
                    ]"
                >
                    <div class="px-4 py-6 space-y-2">
                        <router-link 
                            v-for="(link, index) in navLinks" 
                            :key="index"
                            :to="link.path"
                            class="block px-4 py-3 text-gray-700 font-medium rounded-lg transition-all duration-200 hover:text-green-600 hover:bg-green-50/50"
                            @click="closeNavbar"
                        >
                            {{ link.name }}
                        </router-link>
                        
                        <!-- Mobile CTA -->
                        <router-link 
                            to="/Contact"
                            class="block w-full mt-4 px-6 py-3 bg-gradient-to-r from-green-600 to-teal-600 text-white font-medium rounded-full text-center transition-all duration-300 hover:from-green-700 hover:to-teal-700"
                            @click="closeNavbar"
                        >
                            Get Quote
                        </router-link>
                    </div>
                </div>
            </nav>
        </header>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isOpen: false,
            navLinks: [
                { path: '/', name: 'Home' },
                { path: '/Service', name: 'Services' },
                { path: '/PublicParticipation', name: 'Public Participation' },
                { path: '/Contact', name: 'Contact' }
            ]
        }
    },
    methods: {
        toggleNavbar() {
            this.isOpen = !this.isOpen;
            document.body.classList.toggle('overflow-y-auto', !this.isOpen);
        },
        closeNavbar() {
            this.isOpen = false;
            document.body.classList.add('overflow-y-auto');
        }
    }
}
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>